import type { Basket, Package } from './types'

// premium is a single rank, so the basket holds one premium package at most, once (tebex' subscription stacking
// prevention only covers the subscriptions that are already running)
export function useTebexExclusive() {
  const config = useRuntimeConfig()

  const isExclusive = (pack?: Package) => pack?.category.id == config.public.tebexCategoryPremium

  // other tabs don't know each other's basket, so the whole basket is checked as well
  const exceedsExclusive = (basket: Basket | null, packages: Record<number, Package>) => {
    const items = basket?.packages.filter(item => isExclusive(packages[item.id])) ?? []
    return items.length > 1 || items.some(item => item.in_basket.quantity > 1)
  }

  return { isExclusive, exceedsExclusive }
}
